import React, { Component } from "react"
import { withRouter } from "react-router-dom"

import Grid from "@material-ui/core/Grid"

import TableCell from "@material-ui/core/TableCell"
import TableRow from "@material-ui/core/TableRow"
import Alert from "@material-ui/lab/Alert"
import AlertTitle from "@material-ui/lab/AlertTitle"
import TitleBar from "../../components/TitleBar"
import TitleBarTitle from "../../components/TitleBarTitle"

import { CopyHelper } from "../../classes/Helper"
import internalStore from "../../stores/InternalStore"
import SessionStore from "../../stores/SessionStore"

class NoOrganizationsAvailable extends Component {
  constructor() {
    super()

    this.getPage = this.getPage.bind(this)
    this.getRow = this.getRow.bind(this)
    this.copyToClipBoard = this.copyToClipBoard.bind(this)
    this.tableRef = React.createRef()
  }

  getPage(limit, offset, callbackFunc) {
    let orgId = SessionStore.isAdmin() ? 0 : SessionStore.getOrganizationID()
    internalStore.getStackInfo(orgId, (obj) => {
      let keys = Object.keys(obj)

      let result = keys.map((item, c) => {
        return {
          id: c,
          name: item,
          details: obj[item].replace("\n", ""),
        }
      })
      callbackFunc({ result: result })
    })
  }

  copyToClipBoard(event) {
    CopyHelper({
      target: {
        innerText: event.currentTarget.parentNode.nextSibling.lastChild.innerText,
      },
    })
  }

  getRow(obj) {
    return (
      <TableRow key={obj.id} hover>
        <TableCell>{obj.name}</TableCell>
        <TableCell>{obj.details}</TableCell>
      </TableRow>
    )
  }

  render() {
    return (
      <Grid container spacing={4}>
        <TitleBar>
          <TitleBarTitle title="No organizations available" />
        </TitleBar>

        <Grid item xs={12}>
          <Alert severity="warning" style={{ width: "600px" }}>
            <AlertTitle> You do not have access to projects (organizations)</AlertTitle>
            To obtain the appropriate access, contact the administrators or use the user menu.
          </Alert>
        </Grid>
      </Grid>
    )
  }
}

export default withRouter(NoOrganizationsAvailable)
